import type { FormItemRule } from 'element-plus'

export const urlRule: FormItemRule = {
  pattern:
    /^(?:https?:\/\/)?(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}(?:\/[^\s]*|[^\s]*)?$/,
  message: 'Enter a valid URL',
  trigger: 'blur',
}

export const keywordRule: FormItemRule = {
  pattern: /^[a-zA-Z0-9_\-=]+$/,
  message: 'Allowed characters: letters, numbers, underscore(_), hyphen(-), equal sign(=)',
  trigger: 'blur',
}
